import { Pipe, PipeTransform } from '@angular/core';
import { PriceResult } from '@next/core-lib/cart';

@Pipe({ name: 'formatUnitPrice', standalone: true })
export class FormatUnitPricePipe implements PipeTransform {
  public transform(values: PriceResult[]): string {
    if (values === null || values?.length === 0) {
      return '';
    }

    const priceResult = values[0];
    return priceResult.unitPrice;
  }
}
